import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AuthenticationService } from '../../../data-services/authentication/authentication.service';
import {
  LINKS_IMAGES,
  LINKS_TEMPLATE,
  LINKS_TRAINING,
  LINKS_WEBMAIL,
} from '../../../shared/constants';
import { CompanyService } from '../../../data-services/company/company.service';

@Component({
  selector: 'conn-eweb-links',
  templateUrl: './eweb-links.component.html',
  styleUrls: ['./eweb-links.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EwebLinksComponent implements OnDestroy {
  private authService = inject(AuthenticationService);
  private companyService = inject(CompanyService);

  @Output() fetchManageMySiteUrl: EventEmitter<boolean>;
  @Output() fetchManageMyOmiUrl: EventEmitter<boolean>;
  @Input() isOmi: boolean;
  @Input() items: { imgUrl: string; imgText: string }[];

  childWindow: Window;
  timer = null;
  LINKS_IMAGES = LINKS_IMAGES;
  LINKS_WEBMAIL = LINKS_WEBMAIL;
  LINKS_TEMPLATE = LINKS_TEMPLATE;
  LINKS_TRAINING = LINKS_TRAINING;
  shouldShowManageMyWebsite = true;

  constructor() {
    this.fetchManageMySiteUrl = new EventEmitter<boolean>();
    this.fetchManageMyOmiUrl = new EventEmitter<boolean>();
    // Use CompanyService to determine if Manage My Website should be shown
    this.companyService.shouldShowManageMyWebsite(true).subscribe((result) => {
      this.shouldShowManageMyWebsite = result;
    });
  }

  // https://ngdev.space/angular-2-input-property-changes-detection-3ccbf7e366d2
  @Input()
  set manageMyWebsiteUrl(manageMyWebsiteUrl: string) {
    if (manageMyWebsiteUrl) {
      this.openNewWindow(manageMyWebsiteUrl);
    }
  }

  @Input()
  set manageMyOmiUrl(manageMyOmiUrl: string) {
    if (manageMyOmiUrl) {
      this.openNewWindow(manageMyOmiUrl);
    }
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.childWindow) {
      this.childWindow.close();
    }
  }

  /**
   * Should open a new window based on the link passed in.  If an existing child window already exists that window
   * is closed first before openning the new window
   * */
  openNewWindow(link: string) {
    if (this.childWindow) {
      this.childWindow.close();
    }
    this.startTimer();
    this.childWindow = this.authService.getNativeWindow().open(link);
  }

  startTimer() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if (this.childWindow && this.childWindow.closed) {
          clearInterval(this.timer);
          this.timer = 0;
        }
      }, 500);
    } else {
      clearInterval(this.timer);
      this.timer = 0;
      this.startTimer();
    }
  }
}
